import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import s from "./MyAccount.module.scss";
import { Col, Form, notification, Radio, Row, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { getEntityType, TDropdown } from "../../data";
import { useEffect, useState } from "react";
import { useForm } from "antd/es/form/Form";
import { IUser, IUserWithoutEmail } from "../../types";
import { getMe, updateUser } from "../../redux/UserSlice";
import { CheckCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import Footer from "../../components/Footer/Footer";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import { useTranslation } from "react-i18next";

const MyAccount = () => {
  const { width } = useWindowDimensions();
  const user = useSelector((state: RootState) => state.user.user);
  const [changedValues, setChangedValues] = useState<IUserWithoutEmail>();
  const [userType, setUserType] = useState<string | undefined>(
    user?.entity_type,
  );
  const [form] = useForm();
  const dispatch: AppDispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();
  const [phone, setPhone] = useState<string>(user?.phone || "");
  const { t } = useTranslation();
  const entity_type = getEntityType(t);
  const countries = useSelector(
    (state: RootState) => state.application.countries,
  );

  const openNotification =
    (pauseOnHover: boolean, title: string, type: "success" | "error") => () => {
      let icon;

      switch (type) {
        case "success":
          icon = <CheckCircleOutlined style={{ color: "green" }} />;
          break;

        case "error":
          icon = <WarningOutlined style={{ color: "red" }} />;
          break;
      }
      api.open({
        message: title,
        icon,
        showProgress: true,
        pauseOnHover,
      });
    };

  console.log("user", user);

  useEffect(() => {
    form.setFieldsValue({
      email: user?.email,
      full_name: user?.full_name,
      company_name: user?.company_name,
      owner_name: user?.owner_name,
      company_id: user?.company_id,
      city: user?.city,
      entity_type: user?.entity_type,
      registered_country: user?.registered_country,
      eori: user?.eori,
      phone: user?.phone || "",
    });
  }, [user, form]);

  const onValuesChange = (changed: any, allValues: IUser) => {
    Object.keys(changed).find((key) => {
      if (key !== "email") {
        setChangedValues((prev) => ({ ...prev, ...changed }));
      }
    });
  };

  const sendForm = async (values: IUser) => {
    if (changedValues) {
      const res = await dispatch(updateUser(changedValues));

      if (res.type === "user/updateUser/fulfilled") {
        dispatch(getMe());
        openNotification(true, "Вы обновили личные данные!", "success")();
      }
    }
  };

  return (
    <div className={s.myAccount}>
      {contextHolder}
      {width > 985 ? <Header /> : <MobileHeader />}
      <div className={s.wrapper}>
        <div className={s.content}>
          <div className={s.sidebar}>
            {width > 1000 && (
              <div className={s.avatar}>
                <img src="/noImage.png" className={s.avatar_img} />
              </div>
            )}
            <div className={s.name}>{user?.owner_name}</div>
            <div className={s.email}>{user?.email}</div>
            <div className={s.sidebar_btns}>
              <div className={s.sidebar_item}>
                <Link to="/home" className={s.changeEmailBtn}>
                  {user?.role === "admin"
                    ? t("Все заявления")
                    : t("Мои заявления")}
                </Link>
              </div>
              <div className={s.sidebar_item}>
                <Link to="/changeEmail" className={s.changeEmailBtn}>
                  {t("Сменить Email")}
                </Link>
              </div>
            </div>

            {/* <div className={s.sidebar_item}>
            <Link to='/changePassword' className={s.changeEmailBtn}>
              Сменить Пароль
            </Link>
          </div> */}
          </div>
          <div className={s.form_wrapper}>
            <h2 className={s.h2}>{t("Личный кабинет")}</h2>

            <Form
              form={form}
              className={s.form}
              layout="vertical"
              onFinish={sendForm}
              onValuesChange={onValuesChange}
            >
              <Row gutter={24}>
                {/* <Col span={width > 700 ? 12 : 24}>
                  <Form.Item
                    name='owner_name'
                    label='Наименование/ имя пользователя'
                    rules={[
                      {
                        required: true,
                        message: "Укажите наименование/ имя пользователя",
                      },
                    ]}
                  >
                    <input
                      placeholder='Укажите наименование/ имя пользователя'
                      className={s.input}
                      defaultValue={"user12345"}
                    />
                  </Form.Item>
                </Col> */}
                <Col span={width > 700 ? 12 : 24}>
                  <Form.Item
                    name="full_name"
                    label={t("ФИО представителя")}
                    rules={[
                      {
                        required: true,
                        message: t("Укажите ФИО представителя"),
                      },
                    ]}
                  >
                    <input
                      placeholder={t("Укажите ФИО представителя")}
                      className={s.input}
                      defaultValue={"user12345"}
                    />
                  </Form.Item>
                </Col>
                <Col span={width > 700 ? 12 : 24}>
                  <Form.Item
                    name="entity_type"
                    label={t("Форма регистрации")}
                    className={s.formItem}
                    initialValue={"legal"}
                  >
                    <Radio.Group
                      block
                      options={entity_type}
                      onChange={(e) => setUserType(e.target.value)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              {userType === "legal" && (
                <Row gutter={24}>
                  <Col span={width > 700 ? 12 : 24}>
                    <Form.Item
                      name="company_name"
                      label={t("Наименование компании")}
                      rules={[
                        {
                          required: true,
                          message: t("Укажите наименование компании"),
                        },
                      ]}
                    >
                      <input
                        placeholder={t("Укажите наименование компании")}
                        className={s.input}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={width > 700 ? 12 : 24}>
                    <Form.Item
                      name="company_id"
                      label={t("Идентификационный номер компании")}
                      rules={[
                        {
                          required: true,
                          message: t(
                            "Укажите Идентификационный номер компании",
                          ),
                        },
                      ]}
                    >
                      <input
                        placeholder={t(
                          "Укажите Идентификационный номер компании",
                        )}
                        className={s.input}
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 300,
                          fontSize: "13px",
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row gutter={24}>
                <Col span={width > 700 ? 12 : 24}>
                  <Form.Item
                    name="email"
                    label={t("Email")}
                    rules={[
                      {
                        required: true,
                        message: t("Укажите электронную почту"),
                      },
                    ]}
                  >
                    <input
                      disabled
                      placeholder={t("Укажите вашу электронную почту")}
                      className={s.input}
                    />
                  </Form.Item>
                </Col>
                <Col span={width > 700 ? 12 : 24}>
                  <Form.Item name="phone" label={t("Телефон")}>
                    <PhoneInput
                      defaultCountry="ge"
                      value={phone}
                      onChange={(phone) => setPhone(phone)}
                      className={s.phone_input}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={width > 700 ? 12 : 24}>
                  <Form.Item
                    name="registered_country"
                    label={t("Страна регистрации компании")}
                    className={s.formItem}
                    rules={[
                      {
                        required: true,
                        message: t("Выберите cтранy регистрации компании"),
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      className={s.select}
                      placeholder={t("Выберите cтранy регистрации компании")}
                      options={countries?.map((it) => ({
                        value: it?.id,
                        label: it?.transit_country_name,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={width > 700 ? 12 : 24}>
                  <Form.Item name="city" label={t("Город")}>
                    <input
                      placeholder={t("Укажите город регистрации компании")}
                      className={s.input}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item
                    name="eori"
                    label={t(
                      "EORI (Идентификационный номер уполномоченного экономического оператора)",
                    )}
                    className={s.formItem}
                  >
                    <input
                      placeholder={t("Укажите EORI")}
                      className={s.input}
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 300,
                        fontSize: "13px",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <button className={s.btn}>{t("Изменить")}</button>
              </Row>
            </Form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MyAccount;
